import React, { useState, useEffect, useLayoutEffect } from "react";
import styles from "./listingPopupCard.module.css";
import { prixFormat } from "utils/PrixFormat";
import useTranslation from "next-translate/useTranslation";
import { useDispatch, useSelector } from "react-redux";
import {
    actions as ListingreducerActions,
    selectors as ListingreducerSelectors,
} from "redux/slices/v2/ListingReducer";

import { actions as UserSpaceActions } from "redux/slices/v2/UserSpace";
import { buildListingUrl } from "components/v2/Listings/ListingsRouterUrlHelper";
import { style } from "@mui/system";
import { set_size } from "utils/getImageToDisplay";
import Image from "next/image";
import api_call_v2 from "utils/API_CALL/api_call_v2";

const index = ({
    key,
    listing,
    onListingPress,
    defaultLiked,
}: // fromLp,
    // searchPayload,
    // initialSeachPayload,
    // priority,
    // NoMaxWidth,
    // fromSimilarInside,
    // Imageheight = 0,
    // noSpecificHeight = false,
    {
        key: any;
        listing: any;
        onListingPress?: any;
        defaultLiked?: boolean;
    }) => {
    const [liked, setLiked] = useState(defaultLiked);
    const { t, lang } = useTranslation("annonceAchat");

    const favListings = useSelector(
        ListingreducerSelectors.favoriteListingsSelactor
    );
    const dispatch = useDispatch();

    const mapVsList = useSelector(ListingreducerSelectors.mapVsListSelactor);

    const mapselector = useSelector(ListingreducerSelectors.mapListingSelactor);

    useEffect(() => {
        if (favListings.includes(listing._id)) setLiked(true);
        else setLiked(false);
    }, [favListings]);

    const addDeleteFavourite = (listingId: string, token?: string) => {
        if (favListings.includes(listingId)) {
            api_call_v2(undefined, "post", "deleteFavoris", {
                listingId: listingId,
            })
                .then((res) => {
                    dispatch(
                        ListingreducerActions.setFavListing({
                            favListings: favListings.filter((item) => item !== listingId),
                        })
                    );
                })
                .catch((err) => { })
                .finally();
        } else {
            api_call_v2(undefined, "post", "addFavoris", {
                listingId: listingId,
            })
                .then((res) => {
                    dispatch(
                        ListingreducerActions.setFavListing({
                            favListings: [...favListings, listingId],
                        })
                    );
                })
                .catch((err) => { })
                .finally();
        }
    };

    const onFavoriteIconPress = (listingId: string) => {
        const FBIdToken = localStorage.FBIdToken;
        if (FBIdToken) {
            addDeleteFavourite(listingId, FBIdToken);
        } else {
            dispatch(UserSpaceActions.setIsAuthDialogVisible({ data: true }));
        }
    };
    const [isMobile, setIsMobile] = useState(false);
    useLayoutEffect(() => {
        if (window.innerWidth < 990) setIsMobile(true);
        else setIsMobile(false);
    }, []);

    const buildUrlImageWithOperations = (
        url,
        apply_operations = true,
        operations = [
            // { operation: "linear", a: 2, b: 3 },
            // { operation: "gamma", gamma: 2.2, gammaOut: 2.2 },
            // {
            //   operation: "grayscale",
            // },
            {
                operation: "output",
                format: "webp",
            },
        ]
    ) => {
        if (apply_operations) {
            return `https://us-central1-agenz-website-prod.cloudfunctions.net/ext-image-processing-api-handler/process?operations=${encodeURIComponent(
                JSON.stringify([
                    { operation: "input", type: "url", url: url },
                    ...operations,
                ])
            )}`;
        } else {
            return set_size(url);
        }
    };

    const TransactionOptions = {
        Vente: { label: t("À vendre"), color: "#FF376E" },
        Location: { label: t("À louer"), color: "#FFDC5A" },
        "Projets Neufs": { label: t("Projets Neufs"), color: "#B748D5" },
        Vendu: { label: t("Vendu"), color: "#2291ff" },
    };

    return (
        <div className={styles.SmallCards}
            key={key}>
            <a
                href={buildListingUrl(
                    listing,
                    lang,
                    null,
                    null,
                    mapVsList,
                    true
                )}
                // onClick={(e) => {
                //     e.preventDefault();

                //     window.open(
                //         buildListingUrl(
                //             listing,
                //             lang,
                //             null,
                //             null,
                //             mapVsList
                //         )
                //     );
                // }}
                className={`${styles.cardLink}`}
                target="_blank"
            >
                <div
                    className={styles.photoSectionNoHeight}
                >
                    <Image
                        unoptimized
                        priority={false}
                        alt="Annonce agenz"
                        width={136}
                        height={0}
                        style={{
                            objectFit: "cover",
                            objectPosition: "center",
                            height: "100%",
                        }}
                        src={
                            typeof listing.images == "string"
                                ? buildUrlImageWithOperations(listing.images, false)
                                : listing.images
                                    ? buildUrlImageWithOperations(listing.images[0], false)
                                    : "https://storage.googleapis.com/headers-agenz/logo-agenz/agenz-logo-white.png"
                        }
                    />
                    {listing.virtual_tour ? (
                        <>
                            <div className={styles.VtourCon}>
                                <div className={`${styles.Vtour}`}>
                                    <svg
                                        width="14"
                                        height="16"
                                        viewBox="0 0 14 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            id="Vector"
                                            d="M12.9903 10.773C12.9887 10.6326 12.9893 10.4907 12.9903 10.3456V4.72845C12.9671 4.52397 12.8735 4.37573 12.6652 4.25221C10.9075 3.21456 9.15516 2.1685 7.40664 1.11719C7.15399 0.965278 6.94678 0.957919 6.68818 1.11351C4.92397 2.17481 3.15489 3.22928 1.37823 4.27113C1.14884 4.4057 1.03686 4.55919 1.00818 4.78417C1.00223 4.82832 0.999527 4.87511 1.00007 4.92505C1.01089 6.07308 1.00007 7.22058 1.00818 8.36862C1.00872 8.46113 1.00926 8.55417 1.01035 8.64669C1.01089 8.6777 1.00981 8.70609 1.00818 8.73342V11.4432C1.0493 11.593 1.14938 11.7018 1.31655 11.7975C3.08618 12.8157 4.85148 13.8412 6.61352 14.8726C6.91 15.0455 7.16914 15.0418 7.46236 14.8652C9.18005 13.8312 10.901 12.801 12.6289 11.7828C12.8453 11.655 12.959 11.5084 12.9903 11.3023C12.999 11.2466 13.0017 11.1872 12.999 11.1225C12.9941 11.0064 12.9914 10.8902 12.9903 10.773ZM6.62543 13.7566C6.62543 13.8055 6.61352 13.8549 6.60379 13.9274C6.51452 13.8817 6.44365 13.8491 6.37656 13.8102C4.91369 12.9576 3.45027 12.106 1.99173 11.2461C1.90354 11.194 1.80508 11.0694 1.80454 10.978C1.79372 9.17024 1.79697 7.36251 1.79751 5.55478C1.79751 5.52324 1.80508 5.4917 1.81266 5.43178C1.89705 5.47488 1.95927 5.50379 2.01824 5.53796C3.48869 6.39531 4.96022 7.25107 6.42526 8.11735C6.51885 8.17255 6.61731 8.31132 6.61785 8.41172C6.62975 10.1932 6.62651 11.9751 6.62543 13.7566ZM6.88132 7.46449C5.3611 6.56825 3.83547 5.68146 2.31146 4.79153C2.28225 4.77418 2.2552 4.75263 2.18541 4.7048C3.0007 4.22067 3.78083 3.75809 4.56096 3.29499C5.32702 2.83977 6.09091 2.38087 6.86185 1.93406C6.94245 1.8878 7.09394 1.86678 7.16535 1.90883C8.69206 2.81138 10.2123 3.72497 11.7336 4.63699C11.7482 4.6454 11.7585 4.66169 11.7834 4.68692C11.7282 4.7274 11.6779 4.7705 11.6211 4.80467C10.1533 5.68462 8.68449 6.56246 7.21728 7.44346C7.10313 7.51232 7.0182 7.54439 6.88132 7.46449ZM11.9494 11.2624C10.5455 12.0913 9.14867 12.9308 7.74909 13.7661C7.66686 13.8155 7.58138 13.8596 7.46561 13.9238C7.45641 13.8228 7.44451 13.7498 7.44451 13.6772C7.44342 11.931 7.44072 10.1853 7.451 8.43958C7.45154 8.33392 7.52999 8.18464 7.61979 8.12997C9.08104 7.24319 10.5504 6.36797 12.0182 5.49118C12.0544 5.4691 12.0928 5.45175 12.1799 5.40655C12.1799 5.53533 12.1794 5.6126 12.1799 5.6904C12.1815 7.40982 12.1799 9.12977 12.1907 10.8492C12.1918 11.051 12.1242 11.1593 11.9494 11.2624Z"
                                            fill="#00B4FF"
                                            stroke="#00B4FF"
                                        />
                                    </svg>
                                    {t("Visite 3D")}
                                </div>
                            </div>
                        </>
                    ) : null}
                </div>
                <div className={styles.contentSection}>
                    <div className={styles.cardHeader}>
                        <div className={styles.label}>
                            {
                                // listing?.exclusivite &&
                                listing?.vendu &&
                                    listing.transaction_type === "Vente" ? (
                                    <div className={`${styles.venduMark}`}>{t("Vendu")}</div>
                                ) : (
                                    <div className={`${styles.dateCreationList}`}>
                                        {lang == "fr"
                                            ? listing?.date_fr
                                                ? listing?.date_fr
                                                : listing?.date
                                                    ? listing?.date.split("T")[0]
                                                    : ""
                                            : lang == "en" ? listing.date_en
                                                ? listing.date_en
                                                : listing?.date
                                                    ? listing?.date.split("T")[0]
                                                    : ""
                                                : listing.date_ar
                                                    ? listing.date_ar
                                                    : listing?.date
                                                        ? listing?.date.split("T")[0]
                                                        : ""}{" "}
                                    </div>
                                )}
                            {
                                listing?.exclusivite
                                    // && !listing?.vendu 
                                    ? (
                                        <div className={styles.labelAnnonceVerified}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path d="M5.25003 7.00003L6.4167 8.1667L8.75003 5.83336M4.57029 2.73997C4.98886 2.70657 5.38621 2.54198 5.7058 2.26963C6.45158 1.63408 7.54848 1.63408 8.29426 2.26963C8.61385 2.54198 9.0112 2.70657 9.42977 2.73997C10.4065 2.81792 11.1821 3.59354 11.2601 4.57029C11.2935 4.98886 11.4581 5.38621 11.7304 5.7058C12.366 6.45158 12.366 7.54848 11.7304 8.29426C11.4581 8.61385 11.2935 9.0112 11.2601 9.42977C11.1821 10.4065 10.4065 11.1821 9.42977 11.2601C9.0112 11.2935 8.61385 11.4581 8.29426 11.7304C7.54848 12.366 6.45158 12.366 5.7058 11.7304C5.38621 11.4581 4.98886 11.2935 4.57029 11.2601C3.59354 11.1821 2.81792 10.4065 2.73997 9.42977C2.70657 9.0112 2.54198 8.61385 2.26963 8.29426C1.63408 7.54848 1.63408 6.45158 2.26963 5.7058C2.54198 5.38621 2.70657 4.98886 2.73997 4.57029C2.81792 3.59354 3.59354 2.81792 4.57029 2.73997Z" stroke="white" stroke-width="1.31765" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <span>{t("Exclu Agenz")}</span>
                                        </div>
                                    ) : null}
                        </div>
                        {listing.transaction_type === "Projets Neufs" && !listing?.exclusivite ? (
                            <div className={styles.projetNeuf}>{t("Projet Neuf")}</div>
                        ) : null}
                        <span
                            data-tracking="click"
                            data-value="favoris-listing"
                            className={`${styles.likedHeart} ${liked ? styles.isFavoriteHeart : ""
                                }`}
                            onClick={(e) => {
                                e.preventDefault();
                                onFavoriteIconPress(listing._id);
                            }}
                        >
                            {!liked ? (
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                                    <path d="M17.109 3.03585C18.6282 4.50441 18.6864 6.86749 17.2412 8.40424L9.99965 16.1038L2.75911 8.40422C1.3139 6.86747 1.3721 4.50436 2.89129 3.0358C4.58756 1.39606 7.38119 1.5459 8.87977 3.35668L10.0001 4.70998L11.1196 3.35653C12.6181 1.54574 15.4127 1.39612 17.109 3.03585Z" stroke="#3B484F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            ) : (
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.109 4.03585C18.6282 5.50441 18.6864 7.86749 17.2412 9.40424L9.99965 17.1038L2.75911 9.40422C1.3139 7.86747 1.3721 5.50436 2.89129 4.0358C4.58756 2.39606 7.38119 2.5459 8.87977 4.35668L10.0001 5.70998L11.1196 4.35653C12.6181 2.54574 15.4127 2.39612 17.109 4.03585Z" fill="#4609F0" stroke="#4609F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            )}
                        </span>
                    </div>
                    <div className={styles.priceContainer}>
                        {listing.vendu ? (
                            <span className={styles.subtitleNew}>
                                <i
                                    className={"fas fa-circle"}
                                    style={{
                                        color: TransactionOptions[
                                            listing.transaction_type
                                        ]
                                            ? TransactionOptions[
                                                listing.vendu
                                                    ? "Vendu"
                                                    : listing.transaction_type
                                            ].color
                                            : "red",
                                        fontSize: "14px",
                                    }}
                                />
                                <text>
                                    {t(listing.type)}{" "}
                                    {listing.vendu
                                        ? listing.date_fr
                                            ? `${listing.transaction_type == "Location"
                                                ? t("loué")
                                                : t("vendu")
                                            } ${lang == "ar"
                                                ? listing.date_ar
                                                : lang == "en" ? listing.date_en : listing.date_fr
                                            }`
                                            : ""
                                        : listing.transaction_type == "Location"
                                            ? t("à louer")
                                            : t("à vendre")}{" "}
                                </text>
                            </span>
                        ) : (
                            listing.price_cut ? (
                                <div
                                    style={{ display: "flex", alignItems: "center", flexDirection: "column" }}
                                >
                                    <div className={styles.price}>
                                        <b className={styles.nouveau} style={{ color: "#FF376E" }}>
                                            {prixFormat(Math.floor(listing.prix))}
                                        </b>
                                        <div className={styles.mad} style={{ color: "#FF376E" }}>
                                            {t("DH")}
                                            {listing?.transaction_type === "Location"
                                                ? ` / ${t("mois")}`
                                                : ""}
                                        </div>
                                    </div>
                                    <div className={styles.oldPrice}>
                                        <b className={styles.nouveau} style={{ color: "#757E83" }}>
                                            {prixFormat(Math.floor(listing.old_price))}{" "}
                                            <s style={{ color: "#757E83" }}>
                                                {t("DH")}
                                                {listing?.transaction_type === "Location"
                                                    ? ` / ${t("mois")}`
                                                    : ""}
                                            </s>
                                        </b>
                                        {/* <div className={styles.mad} style={{ color: "#757E83" }}>
                      </div> */}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className={styles.price}>
                                        <b className={styles.nouveau}>
                                            {prixFormat(Math.floor(listing.prix))}
                                        </b>
                                        <div className={styles.mad}>
                                            {t("DH")}
                                            {listing?.transaction_type === "Location"
                                                ? ` / ${t("mois")}`
                                                : ""}
                                        </div>
                                    </div>
                                </>
                            )
                        )}
                    </div>
                    <div className={`${styles.info} ${styles.infoFromLp}`}>
                        {listing.typologie > 0 ? (
                            <>
                                <div>
                                    <div className={styles.rooms}>
                                        <div className={styles.nouveau}>{listing.typologie}</div>
                                        <div className={styles.typeBien}>
                                            {listing?.typologie == 1
                                                ? t(" Ch")
                                                : listing?.typologie < 11
                                                    ? t(" Ch ")
                                                    : t("Ch")}
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.bullet2} />
                            </>
                        ) : null}
                        {listing.sdb > 0 ? (
                            <>
                                <div>
                                    {" "}
                                    <div className={styles.rooms}>
                                        <div className={styles.nouveau}>
                                            {listing.sdb ? listing.sdb : 0}
                                        </div>
                                        <div className={styles.typeBien}>
                                            {listing.sdb == 1
                                                ? t(" sdb")
                                                : listing.sdb < 11
                                                    ? t("sdb ")
                                                    : t("sdb")}
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.bullet2} />
                            </>
                        ) : null}
                        {listing.surface > 0 ? (
                            <>
                                <div className={styles.rooms}>
                                    <div className={styles.nouveau}>{listing.surface}</div>
                                    <div className={styles.typeBien}>{t("m²")}</div>
                                </div>
                                {/* <div className={styles.bullet2} /> */}
                            </>
                        ) : null}
                        {/* {fromLp ? (
                                <div>
                                    <div className={styles.typeAnnonces}>
                                        <div className={styles.typeBien}>
                                            {" "}
                                            {`${t(listing.type)}`}
                                        </div>
                                    </div>
                                </div>
                            ) : null} */}
                    </div>
                    {!listing.vendu ? (
                        <div className={`${styles.type} ${styles.typeAnnonces}`}>
                            <div className={styles.typeBien}>
                                {" "}
                                {`${t(listing.type)}`}{" "}
                                {listing.transaction_type === "Location"
                                    ? t("à louer")
                                    : t("à vendre")
                                }
                            </div>
                        </div>
                    ) : null}
                    <div className={styles.address}>
                        <div className={styles.casablancaLes1}>
                            <p className={styles.locationAdress}>
                                {listing?.commune == "Bouskoura" ||
                                    listing?.commune == "Dar Bouazza"
                                    ? t(listing?.commune?.trim())
                                    : t(listing?.province?.trim())}{" "}
                                {listing?.quartier ? "-" : ""} {t(listing?.quartier?.trim())}
                            </p>
                        </div>
                    </div>
                    <div
                        className={styles.AgenceDiv}
                        style={{ display: "none" }}
                    >
                        <div
                            className={`${styles.agencyName} ${styles.agencyNameNoLp}`}
                        >
                            {listing.agence?.nameEntreprise ||
                                typeof listing.agence == "string"
                                ? t("Annonce par") + " : "
                                : null}
                            {listing.agence?.nameEntreprise
                                ? listing.agence.nameEntreprise
                                : typeof listing.agence == "string"
                                    ? listing.agence
                                    : t("Annonce par le propriétaire")}
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default index;
